<template>
    <div class="map-sensors-status" :class="[variant ? `variant-${variant}` : '', clickable ? 'clickable' : '']"
        @click="$emit('click', $event)">
        <i :class="computedIcon" aria-hidden="true"></i>
        <span v-if="label">{{ label }}</span>
        <span v-else>{{ $t(`map.sensorsStatus.${accuracy}`) }}</span>
    </div>
</template>
<script>
export default {
    name: `map-sensors-status`,
    props: {
        accuracy: { type: String, default: `noSignal` }, // noSignal, lowSignal, mediumSignal, goodSignal, excellentSignal
        variant: { type: String, default: null }, // null, warning, danger
        icon: { type: String, default: null },
        label: { type: String, default: null },
        clickable: { type: Boolean, default: false },
    },
    computed: {
        computedIcon() {
            if (this.icon) return this.icon;
            const icons = {
                noSignal: `fa-solid fa-signal-bars-slash`,
                lowSignal: `fa-solid fa-signal-bars-weak`,
                mediumSignal: `fa-solid fa-signal-bars-fair`,
                goodSignal: `fa-solid fa-signal-bars-good`,
                excellentSignal: `fa-solid fa-signal-bars-strong`,
            };
            return icons[this.accuracy];
        },
    },
}


</script>

<style scoped lang="scss">
.map-sensors-status {
    position: absolute;
    z-index: 1;
    bottom: calc(20px + var(--page-bottom-margin));
    left: 10px;
    background-color: rgb(255, 255, 255);
    padding: 5px 7px;
    display: flex;
    align-items: center;
    gap: 6px;
    border-radius: 9999px;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);

    i {
        font-size: 12px;
        color: #2b2b2b;
    }

    span {
        font-size: 12px;
    }

    &.clickable {
        cursor: pointer;
    }

    &.variant-danger {
        background-color: #ffcccc;
        border: 1px solid #ff0000;

        i {
            color: #cc0000;
        }

        span {
            color: #cc0000;
        }
    }

    &.variant-warning {
        background-color: #ffe1cc;
        border: 1px solid #ff9100;

        i {
            color: #cc6d00;
        }

        span {
            color: #cc6600;
        }
    }
}

.layout-mobile {
    .map-sensors-status {
        top: calc(var(--map-mobile-overlay-top-offset) + 20px);
        bottom: unset;
    }
}
</style>
